/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Template_Audience_DescInputs */



/**
* | output |
* | --- |
* | "Who can choose this conversation type." |
*
* @param {Settings_Template_Audience_DescInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const settings_template_audience_desc = /** @type {((inputs?: Settings_Template_Audience_DescInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Template_Audience_DescInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Wie dit gesprekstype kan kiezen.")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Qui peut choisir ce type de conversation.")
	return /** @type {LocalizedString} */ ("Who can choose this conversation type.")
});